


import MainLayout from '../components/MainLayout';
import React, { useState, useEffect } from "react";
import {fetchData } from '../components/swagger/apiService';



export default function AgentCMS() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const result = await fetchData("/gateway/common/AgentCMS/GetAll");
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

      
    

  return (
    <>
    <MainLayout>

    <div className='container mt-5'>

        <div className='row'>
        <div className='col-12'>

        <div>
      <h1>Data from Swagger API</h1>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>

        </div>
        </div>

    </div>

    </MainLayout>
    </>
  )
}
